export function entityTestPath(...components: string[]) {
  return '/' + ['flow-tester', ...components].join('/');
}
